import { useEffect } from 'react'
import { toast } from '@lib/toasts'
import { Trans, useTranslation } from 'react-i18next'

const INTERVAL_SECONDS = 30

const fetchDeployedVersion = async () => {
  try {
    const response = await fetch('/.version')
    if (!response.ok) return undefined
    return await response.text()
  } catch (e) {
    // swallow network error to address: https://storiedsoftware.sentry.io/issues/7795156432
    if (e instanceof TypeError) return undefined
    throw e
  }
}

export const NewClientVersionNotification = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const interval = setInterval(() => {
      void (async () => {
        const currentVersion = await fetchDeployedVersion()
        if (currentVersion === undefined) return
        if (
          currentVersion.trim() === import.meta.env.VITE_CLIENT_VERSION.trim()
        )
          return

        toast({
          title: t('features.newClientVersionNotification.newVersionAvailable'),
          variant: 'alert',
          dismissable: false,
          sticky: true,
          content: (
            <Trans
              i18nKey="features.newClientVersionNotification.reloadToGetTheLatestUpdate"
              components={{
                reloadLink: (
                  <a
                    href="#"
                    className="text-hyperlink-blue"
                    onClick={(e) => {
                      e.preventDefault()
                      location.reload()
                    }}
                  />
                ),
              }}
            />
          ),
        })

        // No need to check anymore
        clearInterval(interval)
      })()
    }, 1000 * INTERVAL_SECONDS)

    return () => clearInterval(interval)
  }, [t])

  return <></>
}
